// import { useNavigate } from 'react-router-dom';
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';
// import './PlantationTwoOccasions.scss';

// const categoryTitles = [
//   'anniversary',
//   'birthday',
//   'occasion',
//   'gifting',
//   'custom arrangements',
//   'flowers',
//   'flower in vase',
//   'premium flowers'
// ];

// const PlantationTwoOccasions = () => {
//   const navigate = useNavigate();

//   // Fetch all categories from Firestore
//    const { documents: categories } = useCollection('m_categories');
 
//   // Filter only the ones we need
//   const filteredCategories = categories
//     ?.filter(cat => 
//       typeof cat.category === 'string' &&
//       categoryTitles.includes(cat.category.toLowerCase())
//     )
//     .map(cat => ({
//       title: cat.category.charAt(0).toUpperCase() + cat.category.slice(1),
//       category: cat.category,
//       imageUrl: cat.categoryImgUrl || ''
//     }))
//     .filter(cat => cat.imageUrl); // remove any without an image

//   const handleOccasionClick = (category) => {
//     navigate(`/products?category=${encodeURIComponent(category)}`);
//   };

//   return (
//     <section className="occasions-section">
//       <h2>Say it with Flowers</h2>
//       <p className="subtitle">Thoughtful Gifting for Every Occasion</p>

//       <div className="occasions-wrapper">
//         {filteredCategories?.map((item, index) => (
//           <div 
//             className="occasion-card" 
//             key={index}
//             onClick={() => handleOccasionClick(item.category)}
//           >
//             <div className="image-container">
//               <img src={item.imageUrl} alt={item.title} />
//             </div>
//             <h3>{item.title}</h3>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default PlantationTwoOccasions;




import { useNavigate } from 'react-router-dom';
import { useCollection } from '../../../../firebase-files/hooks/useCollection';
import './PlantationTwoOccasions.scss';

const PlantationTwoOccasions = () => {
  const navigate = useNavigate();

  // 🔹 Fetch only "Say it with Flowers" category
  const { documents } = useCollection('m_categories', [
    'category',
    '==',
    'say it with flowers',
  ]);

  if (!documents) return null;

  const categoryDoc = documents[0];

  // 🔹 If category inactive → hide section
  if (!categoryDoc || categoryDoc.status !== 'active') {
    return null;
  }

  // 🔹 Filter active subcategories
  const activeSubCategories = categoryDoc.subCategories
    ?.filter(sub => sub.status === 'active' && sub.subCategoryImgUrl);

  if (!activeSubCategories || activeSubCategories.length === 0) {
    return null;
  }

  const handleOccasionClick = (subCategoryName) => {
    navigate(
      `/products-two?subcategory=${encodeURIComponent(subCategoryName)}`
    );
  };

  return (
    <section className="occasions-section">
      <h2>Say it with Flowers</h2>
      <p className="subtitle">Thoughtful Gifting for Every Occasion</p>

      <div className="occasions-wrapper">
        {activeSubCategories.map((item, index) => (
          <div
            className="occasion-card"
            key={index}
            onClick={() => handleOccasionClick(item.subCategoryName)}
          >
            <div className="image-container">
              <img
                src={item.subCategoryImgUrl}
                alt={item.subCategoryName}
                loading="lazy"
              />
            </div>
            <h3>{item.subCategoryName}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlantationTwoOccasions;
